export const PARTNER_GET_ALL_COURSES = 'PARTNER_GET_ALL_COURSES';
export const PARTNER_GET_BY_PARTNER = 'PARTNER_GET_BY_PARTNER';
export const GET_PARTNER_COURSES = 'GET_PARTNER_COURSES';
export const UPDATE_PARTNER = 'UPDATE_PARTNER';
export const DELETE_PARTNER = 'DELETE_PARTNER';
export const DELETE_INVITATION_PARTNER = 'UPDATE_PARTNER_INVITATION';
export const PARTNER_GET_COURSE_BY_PARTNET_AND_COURSE =
  'PARTNER_GET_COURSE_BY_PARTNET_AND_COURSE';
export const PARTNER_INVITATION_LIST = 'PARTNER_INVITATION_LIST';
export const FETCH_PARTNER_USERS = 'FETCH_PARTNER_USERS';

